import { Component, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { Menu } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { EVENT_ENUM, STORAGE_ENUM } from '../../models/enum';
import { ToastService } from '../../services/common/toast.service';
import { EventService } from '../../services/common/event.service';
import { Avatar } from 'primeng/avatar';
import { ApiService } from '../../services/api/api.service';
import { SplitButton } from 'primeng/splitbutton';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, SplitButton, Avatar, CommonModule, StyleClassModule, AppConfigurator, Menu, RouterModule, ButtonModule],
    styles: [
        `::ng-deep p-avatar span {
            display: flex !important;
        }`
    ],
    template: ` <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <div class="layout-topbar-logo" routerLink="/">
                <img src="/images/truthstart_logo.webp" alt="" srcset="" class="h-12 w-full">
            </div>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <!-- <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
                </button> -->
                <div class="relative">
                    <!-- <button
                        class="layout-topbar-action layout-topbar-action-highlight"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="animate-fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <i class="pi pi-palette"></i>
                    </button> -->
                    <app-configurator />
                </div>
            </div>

            <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                <i class="pi pi-ellipsis-v"></i>
            </button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
                    <!-- <button type="button" class="layout-topbar-action">
                        <i class="pi pi-calendar"></i>
                        <span>Calendar</span>
                    </button>
                    <button type="button" class="layout-topbar-action">
                        <i class="pi pi-inbox"></i>
                        <span>Messages</span>
                    </button> -->
                    <ng-container *ngIf="!isLoggedIn">
                        <p-button label="SignIn" [routerLink]="['/auth/login']" rounded />
                        <p-button label="SignUp" [routerLink]="['/auth/signup']" rounded />
                    </ng-container>
                    <ng-container *ngIf="isLoggedIn">
                       <p-splitbutton size="small" severity="secondary" icon="pi pi-user" styleClass="h-full" [label]="selectedKundali?.label" [model]="kundaliMenuList" />
                    </ng-container>
                    <ng-container  *ngIf="isLoggedIn">
                        <button type="button" class="layout-topbar-action text-dark" (click)="menu.toggle($event)">
                            <p-avatar label="D" shape="circle" styleClass="text-dark" />
                        </button>
                        <p-menu #menu [model]="profileMenu" [popup]="true" />    
                    </ng-container>
                    
                </div>
            </div>
        </div>
    </div>`
})
export class AppTopbar {

    router: Router = inject(Router);
    items!: MenuItem[];
    profileMenu: MenuItem[] = [];
    kundaliMenuList: MenuItem[] = [];
    selectedKundali: any;

    isLoggedIn: boolean = false;
    user: any;

    constructor(
        public layoutService: LayoutService,
        private toastService: ToastService,
        private eventService: EventService,
        private apiService: ApiService
    ) {
        this.eventService.publish(EVENT_ENUM.LOGOUT, false);
        this.checkUser();
    }

    checkUser() {
        const userStr = sessionStorage.getItem(STORAGE_ENUM.TOKEN);
        if (userStr) {
            this.user = JSON.parse(atob(userStr));
            this.profileMenu = [
                {
                    items: [
                        {
                            label: this.user?.email,
                            icon: 'pi pi-user'
                        },
                        {
                            label: 'Profile',
                            icon: 'pi pi-user-edit',
                            command: () => this.router.navigate(['/profile/me'])
                        },
                        {
                            label: 'Purchases',
                            icon: 'pi pi-credit-card'
                        },
                        {
                            label: 'Referral',
                            icon: 'pi pi-share-alt'
                        },
                        {
                            label: 'Setting',
                            icon: 'pi pi-cog'
                        },
                        {
                            label: 'Subscription',
                            icon: 'pi pi-wallet'
                        },
                        {
                            label: 'Logout',
                            icon: 'pi pi-sign-out',
                            command: () => {
                                sessionStorage.clear();
                                this.checkUser();
                                this.toastService.showSuccess('Logout Successfully');
                                this.router.navigate(['/'])

                            }
                        }
                    ]
                }
            ]
            this.isLoggedIn = true;
            this.getKundaliList()
        } else {
            this.isLoggedIn = false;
        }
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    getKundaliList() {
        if (!this.isLoggedIn) {
            return;
        }
        this.apiService.getKundaliList().subscribe({
            next: (res: any) => {
                if (res?.kundali?.length) {
                    const items: MenuItem[] = [];
                    res?.kundali?.map((data: any) => {
                        items.push({
                            label: `${data.firstName} ${data.lastName}`,
                            data: {
                                ...data
                            },
                            command: (event: any) => this.handleKundaliClick(event?.item)
                        })
                    })
                    const currentKundaliProfileStr = sessionStorage.getItem(STORAGE_ENUM.CURRENT_KUNDALI_PROFILE);

                    if (currentKundaliProfileStr) {
                        this.selectedKundali = JSON.parse(currentKundaliProfileStr);
                    } else {
                        this.selectedKundali = items[0];
                        sessionStorage.setItem(STORAGE_ENUM.CURRENT_KUNDALI_PROFILE, JSON.stringify(this.selectedKundali));
                    }

                    this.kundaliMenuList = items;
                }
            }
        })
    }

    handleKundaliClick(data: any) {
        this.selectedKundali = data;
        sessionStorage.setItem(STORAGE_ENUM.CURRENT_KUNDALI_PROFILE, JSON.stringify(this.selectedKundali));
        this.eventService.publish(EVENT_ENUM.PROFILE_CHANGE, true);
    }
}
